import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ReportTabOption,
  SourcesReportResponse,
} from '../../containers/ReportPage/types';

interface CityOrder {
  title: string;
  orders: SourcesReportResponse[];
}

interface PaymentSectionProps {
  title: string;
  amount: string;
  quantityKey: string;
  quantityRefundKey: string;
  currentTab: ReportTabOption;
  cityOrders: CityOrder[];
  getCountByPaymentPlace: (data: SourcesReportResponse[]) => number;
  getPriceByCityAndPayment: (data: SourcesReportResponse[]) => number;
}

const PaymentSection = ({
  title,
  amount,
  quantityKey,
  quantityRefundKey,
  currentTab,
  cityOrders,
  getCountByPaymentPlace,
  getPriceByCityAndPayment,
}: PaymentSectionProps) => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);

  const handleAccordionClick = (index: number) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const totalCount = cityOrders.reduce(
    (acc, el) => acc + getCountByPaymentPlace(el.orders),
    0
  );

  return (
    <div className="flex-container">
      <div className="amount-block">
        <div
          className="title section-toggle"
          onClick={() => setIsCollapsed(!isCollapsed)}
          style={{
            cursor: 'pointer',
            userSelect: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              transition: 'transform 0.2s ease',
              transform: isCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)',
              flexShrink: 0,
            }}
          >
            <path
              d="M2 4L6 8L10 4"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {title}
          {isCollapsed && (
            <span className="closed-amount" style={{ marginLeft: 'auto' }}>
              {amount}
            </span>
          )}
        </div>
        {!isCollapsed && <div className="closed-amount">{amount}</div>}
      </div>

      {!isCollapsed && (
        <>
          <div className="quantity-block quantity-block-place">
            <div className="title">
              {t(
                `OrdersPage.${
                  currentTab === ReportTabOption.refunds
                    ? quantityRefundKey
                    : quantityKey
                }`
              )}
            </div>
            <div className="closed-amount">{totalCount}</div>
          </div>

          <div className="closed-order">
            {cityOrders.map((el, index) => (
              <div key={el.title}>
                <div
                  className="city-price-block"
                  onClick={() => handleAccordionClick(index)}
                >
                  <div>
                    <span className="city">{el.title}</span>
                    <span className="city-price">
                      {getPriceByCityAndPayment(el.orders)} ₸
                    </span>
                  </div>
                  <div className="accordion-button">
                    {activeIndex === index ? 'Скрыть детали' : 'Открыть'}
                  </div>
                </div>

                {activeIndex === index &&
                  el.orders?.map((source: any, sourceIndex: number) => (
                    <div className="network-block" key={source.source_code}>
                      <div className="network-code">{source.source_name}</div>
                      <div className="orders">
                        {source.orders.map(
                          (e: any) =>
                            (currentTab === ReportTabOption.sales ||
                              (currentTab === ReportTabOption.refunds &&
                                e.refund_sum)) && (
                              <div className="order" key={e.order_id}>
                                №{e.order_id}{' '}
                                <span>
                                  (
                                  {currentTab === ReportTabOption.refunds
                                    ? e.refund_sum
                                    : e.sum}{' '}
                                  ₸)
                                </span>
                              </div>
                            )
                        )}
                      </div>
                      {/* @ts-ignore */}
                      <div className="amount-orders">
                        {sourceIndex === 0 && (
                          <>
                            {t('OrdersPage.AMOUNT_ORDERS')}: <br />
                          </>
                        )}
                        <span>
                          {currentTab === ReportTabOption.refunds
                            ? source.refund_total
                            : source.total}{' '}
                          ₸
                        </span>
                      </div>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default PaymentSection;
